import { useEffect, useState } from "react";
import Button from "../../Components/Button/Button";
import Input from "../../Components/Input/Input";
import PortalFooter from "../../Components/Reactportal/PortalFooter";
import Reactportal from "../../Components/Reactportal/Reactportal";
import { ErrorToast, SuccessToast } from "../../Components/ToastComponent/RectHotToast";
import AddUserRights from "./AddUserRights/AddUserRights";
import "./UserRights.scss";
import { EditRole, getUserRights, RolesData } from "../../../Utils/AllPagesQuriesAndMutations";
import { useSelector } from "react-redux";
const { useQuery, gql, useMutation } = require("@apollo/client");

export const UserRights = ({ ParentPortalCloseFunction }) => {
  const FormDataFromRedux = useSelector((store) => store?.FormDataReducer);
  const [toggle, settoggle] = useState(true);
  const [Role, setRole] = useState("");
  const [roleId, setRoleId] = useState("");
  const [roleIds, setRoleIds] = useState("");
  const [allData, setAllData] = useState([]);
  const [roleNames, setRoleNames] = useState([]);
  const [UpdatedRights, setUpdatedRights] = useState([]);
  const [searchPage, setPageName] = useState("");
  const [selectedRole, setSelectedRole] = useState(null);
  const TypeOfPortal = "User Rights";

  // Q & M
  const [editRole, { loading }] = useMutation(EditRole);

  const { refetch: RightsRefetch } = useQuery(getUserRights, {
    variables: {
      roleId: "",
    },
  });

  const { data: RoleData } = useQuery(RolesData, {
    variables: {
      keyword: "",
    },
  });

  // const { refetch: RefetchSearchRoleData } = useQuery(searchRoles, {
  //   variables: {
  //     keyword: Role,
  //   },
  // });

  // useEffect(() => {
  //   console.log(Role);
  //   RefetchSearchRoleData({ keyword: Role })
  //     .then((res) => {
  //       console.log(res);
  //       // setRoleNames(res.data);
  //     })
  //     .catch((err) => console.log(err));
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [Role]);

  const [roleData, setRoleData] = useState(RoleData ? RoleData.Roles : "");
  useEffect(() => {
    if (RoleData && RoleData.searchRoles) {
      setRoleData(RoleData.searchRoles);
    }
  }, [RoleData]);
  const Closeformfunction = () => {
    settoggle(false);
    ParentPortalCloseFunction()
  };

  useEffect(() => {
    if (roleData && roleData.length > 0) {
      let roleN = roleData.map((e) => e.Role);
      let roleIdsarr = roleData.map((e) => e._id);

      setRoleNames(roleN);
      setRoleIds(roleIdsarr);
    }
  }, [roleData]);

  const handleChange = (e) => {
    const selected = roleData.find((r) => r.Role === e.target.value);
    setSelectedRole(selected);
    setRole(e.target.value);
  };

  const handleGo = () => {
    let roleid = FormDataFromRedux?.MasterData["User_Page_rights"]?.User_Right?._id;
    RightsRefetch({ roleId: roleid }).then((res) => setAllData(res.data.GetModuleRightsBy_Role_Id));
  };

  useEffect(() => {
    for (let i = 0; i < roleNames?.length; i++) {
      if (Role === roleNames[i]) {
        setRoleId(roleIds[i]);
        break;
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [Role]);

  useEffect(() => {
    return () => {
      ParentPortalCloseFunction()
    }
  }, [])
  const submit = () => {
    editRole({
      variables: {
        userInput: UpdatedRights,
      },
    })
      .then((res) => {
        handleGo();
        SuccessToast(res.data.editUserPageWithArrayoFID.message);
      })
      .catch((err) => {
        settoggle(toggle);
        ErrorToast("Something went wrong! Please Check fields and try again.");
      });
  };

  return (
    <div className="RightsContainer">
      <Reactportal
        open={toggle}
        onClose={Closeformfunction}
        TypeOfPortal={TypeOfPortal}
        TypeOfId={"Account Id :"}
        UserRightsPortal={true}
      >
        <div className="UserRightsContainer">
          <div className="RightsHeader">
            <div className="RightsHeaderDiv">
              <Input
                EMTQuery=""
                checked={""}
                InputConfig={{
                  masterName: "Role",
                }}
                type="InputDropForQuery"
                name="User_Right"
                dropdowndata={roleNames}
                handleBlur={() => { }}
                handleInputChange={(e) => {
                  handleChange(e);
                }}
                label={"User Role"}
                modalform={true}
                Iconinside={true}
                formkey="User_Page_rights"
                value={selectedRole?.Search_Value || Role}
              />
              <Button name="gobutton" text="GO" action={handleGo}></Button>
            </div>
            <div className="RightsHeaderDiv">
              <Input
                EMTQuery=""
                checked={""}
                InputConfig=""
                type="text"
                name="Page"
                handleBlur={() => { }}
                value={searchPage}
                handleInputChange={(e) => {
                  setPageName(e.target.value);
                }}
                label={"Search Page"}
                modalform={true}
                Iconinside={true}
                disabled={!allData.length}
              />
            </div>
          </div>
        </div>
        <div className="TableContainer">
          <AddUserRights searchPage={searchPage} data={allData} handleRights={(data) => setUpdatedRights(data)} />
        </div>
        <PortalFooter
          renderContent={() => <></>}
          disabled={false}
          submitform={submit}
          SaveAndClose={() => {
            Closeformfunction();
            submit("close");
          }}
          handleformclose={() => {
            Closeformfunction();
            settoggle(!toggle);
          }}
          submitType={"Submit"}
          UserRightsPortal={true}
          loadingState={loading}
        />
      </Reactportal>
    </div>
  );
};
